export default (props = {}) => <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"{...props}>
<g id="vuesax/linear/danger">
<g id="danger">
<path id="Vector" d="M14 10.5V16.3333" stroke="#EF6346" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
<path id="Vector_2" d="M13.9981 24.9772H6.92805C2.87972 24.9772 1.18805 22.0839 3.14805 18.5489L6.78805 11.9922L10.2181 5.83219C12.2947 2.08719 15.7014 2.08719 17.7781 5.83219L21.2081 12.0039L24.8481 18.5605C26.8081 22.0955 25.1047 24.9889 21.0681 24.9889H13.9981V24.9772Z" stroke="#EF6346" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
<path id="Vector_3" d="M13.9922 19.834H14.0027" stroke="#EF6346" stroke-width="2.33333" stroke-linecap="round" stroke-linejoin="round"/>
</g>
</g>
</svg>
